export enum LessonType {
  LegacyExam = 'EXAM',
  Theory = 'THEORY',
  Revision = 'REVISION',
  Custom = 'CUSTOM',
}

export const LESSON_TYPE_LABELS: Record<LessonType, string> = {
  [LessonType.LegacyExam]: 'Exam',
  [LessonType.Theory]: 'Theory',
  [LessonType.Revision]: 'Revision',
  [LessonType.Custom]: 'Custom',
};
